import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';

export type AutocompleteNoOptionsPlaceholderProps = {
  className?: string;
};

export function AutocompleteNoOptionsPlaceholder({
  children,
  className,
}: PropsWithChildren<AutocompleteNoOptionsPlaceholderProps>) {
  return (
    <div className={classNames('relative cursor-default select-none py-2 px-3 text-secondary', className)}>
      {children}
    </div>
  );
}

export default AutocompleteNoOptionsPlaceholder;
